var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateUUID } from '../utils/uuid';
/**
 * Event Emitter Service
 * Handles sending events to the backend
 * Automatically generates unique eventId for deduplication
 */
export class EventEmitter {
    constructor(apiClient) {
        this.sessionId = null;
        this.eventQueue = [];
        this.isProcessing = false;
        this.getAdContext = null;
        this.apiClient = apiClient;
    }
    /**
     * Set the ad context provider function
     */
    setAdContextProvider(getAdContext) {
        this.getAdContext = getAdContext;
    }
    /**
     * Set the session ID (called after init)
     */
    setSessionId(sessionId) {
        this.sessionId = sessionId;
        this.processQueue();
    }
    /**
     * Emit an event
     */
    emit(eventType, eventData) {
        return __awaiter(this, void 0, void 0, function* () {
            // Automatically add unique event ID if not provided (for deduplication)
            const enrichedData = Object.assign({}, eventData);
            if (!enrichedData.eventId) {
                enrichedData.eventId = generateUUID();
            }
            // Automatically add timestamp if not provided (for replay protection)
            if (!enrichedData.timestamp) {
                enrichedData.timestamp = Date.now();
            }
            // Automatically add ad context if available
            if (this.getAdContext && !enrichedData.adContext) {
                enrichedData.adContext = this.getAdContext();
            }
            if (!this.sessionId) {
                // Queue events if session not initialized yet
                this.eventQueue.push({ type: eventType, data: enrichedData });
                return;
            }
            try {
                yield this.apiClient.sendEvent(this.sessionId, eventType, enrichedData);
            }
            catch (error) {
                console.warn('[GetJarAds] Failed to send event:', eventType, error);
                // Fail safely - don't throw
            }
        });
    }
    /**
     * Process queued events after session is initialized
     */
    processQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isProcessing || !this.sessionId || this.eventQueue.length === 0) {
                return;
            }
            this.isProcessing = true;
            while (this.eventQueue.length > 0) {
                const event = this.eventQueue.shift();
                if (event) {
                    try {
                        // Add event ID if not already present (for queued events)
                        const enrichedData = Object.assign({}, event.data);
                        if (!enrichedData.eventId) {
                            enrichedData.eventId = generateUUID();
                        }
                        // Add timestamp if not already present (for queued events)
                        if (!enrichedData.timestamp) {
                            enrichedData.timestamp = Date.now();
                        }
                        // Add context if not already present (for queued events)
                        if (this.getAdContext && !enrichedData.adContext) {
                            enrichedData.adContext = this.getAdContext();
                        }
                        yield this.apiClient.sendEvent(this.sessionId, event.type, enrichedData);
                    }
                    catch (error) {
                        console.warn('[GetJarAds] Failed to send queued event:', event.type, error);
                    }
                }
            }
            this.isProcessing = false;
        });
    }
}
